import React, { useState, useEffect } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { TrustStrip } from "@/components/site/TrustStrip";
import { SheinSpotlight } from "@/components/site/SheinSpotlight";
import { ProcessSteps } from "@/components/site/ProcessSteps";
import { CandidateForm } from "@/components/site/CandidateForm";
import { JobCatalog } from "@/components/site/JobCatalog";
import { WhoWeAre } from "@/components/site/WhoWeAre";
import { Testimonials } from "@/components/site/Testimonials";
import { Employers } from "@/components/site/Employers";
import { ContactSection } from "@/components/site/ContactSection";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";

export default function Landing() {
  const [selectedJob, setSelectedJob] = useState(null);

  const scrollToForm = (job) => {
    if (job && job.id) setSelectedJob(job);
    document.querySelector("#aplicar")?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 400);
    }
  }, []);

  return (
    <div className="bg-[#0B132B] min-h-screen">
      <Navbar />
      <Hero onApply={() => scrollToForm(null)} />
      <TrustStrip />
      <SheinSpotlight onApply={() => scrollToForm(null)} />
      <ProcessSteps />
      <CandidateForm selectedJob={selectedJob} />
      <JobCatalog onApply={scrollToForm} />
      <WhoWeAre />
      <Testimonials />
      <Employers />
      <ContactSection />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
